$(document).ready( function() {

  function validEmailAddress( email ) {
      var pattern = new RegExp( /^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i );
      return pattern.test( email );
  }

  $('#nl-subscribe-butt').click( function() {

    ga('send', 'event', 'newsletter', 'subscribe-click');
    var email_addr = $('#nl-subscribe-email').val();

    if( !validEmailAddress(email_addr) ) {
      $('.nl-subscribe-message.error').animate( {opacity:1}, 300 ).delay(4000).animate( {opacity:0}, 300 );
      ga('send', 'event', 'newsletter', 'subscribe-fail');
      return false;
    } else if( email_addr == '' ) {
      $('.nl-subscribe-message.error').animate( {opacity:1}, 300 ).delay(4000).animate( {opacity:0}, 300 );
      ga('send', 'event', 'newsletter', 'subscribe-fail');
      return false;
    }

    $.post( "./api/newsletter-subscribe.php", { email:email_addr }, function( result ) {

      if( result == 1 ) {
        ga('send', 'event', 'newsletter', 'subscribe-success');
        $('.nl-subscribe-message.success').animate( {opacity:1}, 300 ).delay(4000).animate( {opacity:0}, 300 );
        $('#nl-subscribe-email').val('');
      } else {
        $('.nl-subscribe-message.error').animate( {opacity:1}, 300 ).delay(4000).animate( {opacity:0}, 300 );
        ga('send', 'event', 'newsletter', 'subscribe-fail');
      }

    }, "json" );


  } );

} );



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/newsletter.js
 ** module id = 144
 ** module chunks = 0
 **/